import { isCustomizedType, reduce } from "et3-type-guards";
import { Ti18nKeys } from "../../constants/i18n";
import i18nServerResponse from "../../constants/i18n-server-response";
import { post } from "../axios-post";

export const apiCallUpdateFcmToken = async ({
  fcmToken
}: {
  fcmToken: string;
}): Promise<{
  status: string;
  code: Ti18nKeys;
}> => {
  const { status, data, et3Error } = await post(`core/updateFcmToken`, {
    fcmToken
  });

  if (
    status === "OK" &&
    !isCustomizedType<{
      errorCode: string;
      et3Message: string;
    }>(
      {
        errorCode: "ERROR",
        et3Message: "ERROR"
      },
      data
    )
  ) {
    return {
      status: "OK",
      code: "SUCCESS"
    };
  } else if (status === "ERROR") {
    const errorNumber = reduce(() => et3Error.errorNumber, 0);
    return {
      status: "ERROR",
      code: i18nServerResponse.get(errorNumber)
    };
  } else {
    return {
      status: "ERROR",
      code: "ERROR"
    };
  }
};
